export const SESSION_EXPIRED_CODE = 'SESSION_EXPIRED';

type ErrorLike = {
  code?: unknown;
  response?: { status?: unknown };
};

export function createSessionExpiredError(message = 'Session expired'): Error {
  const error = new Error(message) as Error & { code: string };
  error.code = SESSION_EXPIRED_CODE;
  return error;
}

export function isDefinitiveAuthFailure(error: unknown): boolean {
  const candidate = error as ErrorLike | null | undefined;
  const status = candidate?.response?.status;
  return candidate?.code === SESSION_EXPIRED_CODE || status === 401 || status === 403;
}

export function shouldRetryWithRotatedToken(
  error: unknown,
  attemptedToken: string,
  storedToken: string | null,
): storedToken is string {
  return isDefinitiveAuthFailure(error) && !!storedToken && storedToken !== attemptedToken;
}
